export default {
    adBanners: {collection: []},
    flexibleForm: {fields: [], errors: {}}
}